var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "promotions" },
    [
      _c("h2", { staticClass: "title" }, [_vm._v("\n    Уведомления\n  ")]),
      _vm.isSubscribed
        ? _c(
            "div",
            { staticClass: "promotions-items" },
            [
              _vm.COUPONS.length
                ? _c(
                    "div",
                    { staticClass: "promotions-items-wrapper" },
                    _vm._l(_vm.COUPONS, function(coupon) {
                      return _c("promotion-item", {
                        key: coupon.id,
                        attrs: { info: coupon }
                      })
                    }),
                    1
                  )
                : _c("page-info", {
                    staticClass: "page-info",
                    attrs: {
                      title: "Список уведомлений пуст",
                      subtitle:
                        "Все новые персональные предложения, уведомления об акциях и скидках будут отображаться здесь"
                    }
                  })
            ],
            1
          )
        : _c(
            "page-info",
            {
              attrs: {
                title:
                  "Вы не получаете уведомления об акциях, новиках и скидках",
                subtitle:
                  "Чтобы получать уведомления необходимо подписаться на рассылку"
              }
            },
            [
              _c("ui-button", {
                attrs: { text: "Подписаться" },
                on: {
                  click: function($event) {
                    return _vm.navigate("/account/subscribes")
                  }
                }
              })
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }